import { BounceZoomIn, BounceZoomOut } from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contract";
import soundManager from "slotworks/sound/sound-manager";
import gameState from "slotworks/model/game-state";
import ICSpinRecord from "integration/revolver/schema/spin-record";
import settingsModel from "slotworks/model/settings/settings-model";
import RevolverWinTransitions from "./revolver-win-transitions";
import * as particles from "pixi-particles";
import revolverModel from "slotworks/integration/revolver/model/revolver-model";
import RevolverSettings from "model/revolver-settings";

export default class LineWinTransitions extends AbstractSceneTransition {

    private BOUNCE_TIME: number = 300;
    private noWinWin: boolean;
    protected static coinFountain: particles.Emitter;

    public in(): Contract<void> {
        return new Contract((resolve) => {
            this.noWinWin = settingsModel.isUKJurisdiction() && !gameState.getCurrentGame().isWinAboveBet();
            if (this.noWinWin) {
                this.formatLowWinText();
                resolve(null);
            } else {
                // Only start coin fountain if BOUNCE_TIME is greater than 0
                if (!RevolverSettings.isCountupPlayed) {
                    Layers.Custom.get("Coins").show();
                    LineWinTransitions.coinFountain = Layers.Custom.get("Coins").getParticle("coin");
                    LineWinTransitions.coinFountain.emit = true;
                }
                BounceZoomIn(Layers.CelebrationContent.getSprite("value"), this.BOUNCE_TIME, 0).then(resolve);
            }
        });
    }

    public out(): Contract<void> {
        return new Contract((resolve) => {
            if (this.noWinWin) {
                RevolverSettings.isCountupPlayed = false;
            } else {
                LineWinTransitions.coinFountain = Layers.Custom.get("Coins").getParticle("coin");
                LineWinTransitions.coinFountain.emit = false;
                RevolverSettings.isCountupPlayed = true;
                const record = gameState.getCurrentGame().getCurrentRecord() as ICSpinRecord;
                if (record.timesCycled <= 1 && !(settingsModel.isUKJurisdiction() && record.creditsWon <= gameState.getCurrentGame().totalBet))
                    soundManager.customEvent("lines_win_out");
                BounceZoomOut(Layers.CelebrationContent.getSprite("value"), this.BOUNCE_TIME, 0).then(resolve);
            }
        });
    }

    private formatLowWinText() {
        const text = Layers.CelebrationContent.getSprite("value");
        const scale = text.scale.x * 0.6;
        text.scale.set(scale, scale);
        text.tint = 0xcccccc;
    }

}
